<template>
    <div class="my-claims-container">
        <h2>My Claims</h2>

        <div class="left">
            <NewClaimForm class="new-claim-form" @change="syncClaim"></NewClaimForm>
            <Button icon="plus" class="button" @click="createClaim">Create Claim</Button>
        </div>
       
        <div class="right">
            <ClaimTable 
                class="claim-table"
                :claims="rootClaims" 
                @claimSelected="claimSelected"
            >
            </ClaimTable>
        </div>
    </div>
</template>

<script>
    import Button from '../components/Button.vue';
    import ClaimTable from '../components/ClaimTable.vue';
    import NewClaimForm from '../components/NewClaimForm.vue';

    export default {
        created() {
            this.$store.dispatch('claims/loadClaims');
        },
        methods: {
            syncClaim: function(e) {
                this.newClaim = {
                    id: this.newClaim.id,
                    ...e
                };
            },
            createClaim: function() {
                this.$store.dispatch('claims/createClaim', this.newClaim);
            },
            claimSelected: function(e) {
                this.$router.push({name: 'Claim', params: {id: e.id} });
            }
        },
        data() {
            return {
                newClaim: { id: this.$id() }
            };
        },
        computed: {
            rootClaims() {
                return this.$store.getters['claims/getRootClaims'];
            }
        },
        components: {
            Button,
            ClaimTable,
            NewClaimForm
        }
    }
</script>

<style scoped lang="scss">
    .button {
        width: $space-256;
    }

    .my-claims-container {
        position: relative;
        width: 100%;

        h2 {
            text-align: left;
        }

        .left {
            position: absolute;
            left: 0;
            top: $space-64;
        }

        .right {
            position: absolute;
            left: $space-512 + $space-32;
            top: $space-64;
        }
    }

    .new-claim-form {
        width: $space-512;
    }

    .claim-table {
        margin: 0 auto;
    }
</style>